import React from "react";

export default function HeaderSkill() {
  return (
    <div className="mb-10">
      <h1 className="font-bold text-2xl">Skill matrix</h1>
    </div>
  );
}
